import { setContext } from '@apollo/client/link/context';

export const authLink = setContext((_, { headers }) => {
  // get the token from the URL
  const match = /\/l\/(\w+)/.exec(location.pathname);
  if (!match) throw new Error('No auth token found in the URL');
  let token = match[1];

  const newToken = sessionStorage.getItem('token');

  if (newToken) {
    token = newToken;
  }

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`
    }
  };
});
